import React, { useEffect } from 'react';
import './KG/Modal.css';
import './shared.css';

interface ConfirmModalProps {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onCancel]);

  return (
  <div className="modal-overlay" onClick={onCancel}>
    <div
      className="modal-content"
      style={{ maxWidth: 420 }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header">
        <h2>{title}</h2>
      </div>
      <div className="modal-body" style={{ padding: '20px 24px' }}>
        <p style={{ margin: 0, lineHeight: 1.5 }}>{message}</p>
      </div>
      <div className="modal-footer" style={{ padding: '12px 24px 20px', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <button className="tab-btn tab-btn--ghost" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          className={`tab-btn ${danger ? 'tab-btn--danger' : 'tab-btn--primary'}`}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
  );
};

export default ConfirmModal;
